import ExpiredLink from './expiredLink'

export default ExpiredLink